import type { ImageCropParams } from '~/shared/types/image-crop'
import { isNonEmptyString } from '~/shared/utils/guards'

const BASE_URL = '/api/v1/yavagro/images/resize'

const DEFAULT_PARAMS: Partial<ImageCropParams> = {
  quality: 90,
}

export function cropImage(path: string, params: ImageCropParams = {}): string {
  const mergedParams = { ...DEFAULT_PARAMS, ...params }

  let url = `${BASE_URL}?url=${path}`

  for (const [key, value] of Object.entries(mergedParams)) {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        url += `&${key}=${value.join(',')}`
      } else {
        url += `&${key}=${value}`
      }
    }
  }

  return url
}

export function toCroppedImage(value: unknown, params: ImageCropParams = {}): string {
  return isNonEmptyString(value) ? cropImage(value, params) : ''
}
